/* eslint-disable no-unused-vars */
import { memo } from 'react';
import * as S1 from './Section.styled';
import { useFormContext, Controller } from 'react-hook-form';
import { CustomInput } from 'components';
import { requireRules, emailValidationRules, phoneValidationRules } from './validation';

const inputWidth = 285;

export const FinanceContactSection = memo(() => {
  const { control } = useFormContext();

  return (
    <S1.SectionBox style={{ marginTop: '32px' }}>
      <S1.Row>
        <S1.FieldName isRequired>First Name</S1.FieldName>
        <Controller
          rules={requireRules}
          name='companyInformation.financeContactDetails.firstName'
          control={control}
          render={({ field, fieldState, formState }) => {
            const { name, onChange, value } = field;
            const { invalid } = fieldState;
            return (
              <CustomInput
                value={value}
                autoComplete='off'
                id={name}
                name={name}
                error={invalid}
                onChange={onChange}
                width={inputWidth}
              />
            );
          }}
        />
      </S1.Row>
      <S1.Row>
        <S1.FieldName isRequired>Last Name</S1.FieldName>
        <Controller
          rules={requireRules}
          name='companyInformation.financeContactDetails.lastName'
          control={control}
          render={({ field, fieldState, formState }) => {
            const { name, onChange, value } = field;
            const { invalid } = fieldState;
            return (
              <CustomInput
                value={value}
                autoComplete='off'
                id={name}
                name={name}
                error={invalid}
                onChange={onChange}
                width={inputWidth}
              />
            );
          }}
        />
      </S1.Row>
      <S1.Row>
        <S1.FieldName isRequired>Email</S1.FieldName>
        <Controller
          rules={emailValidationRules}
          name='companyInformation.financeContactDetails.email'
          control={control}
          render={({ field, fieldState, formState }) => {
            const { name, onChange, value } = field;
            const { invalid } = fieldState;
            return (
              <CustomInput
                value={value}
                autoComplete='off'
                id={name}
                name={name}
                error={invalid}
                onChange={onChange}
                width={inputWidth}
              />
            );
          }}
        />
      </S1.Row>
      <S1.PhoneRow>
        <S1.FieldName isRequired>Phone Number</S1.FieldName>
        <S1.PhoneInputWrap>
          <Controller
            rules={{
              ...requireRules,
              ...phoneValidationRules,
            }}
            name='companyInformation.financeContactDetails.phoneNumber'
            control={control}
            render={({ field, fieldState, formState }) => {
              const { name, onChange, value } = field;
              const { invalid } = fieldState;
              return (
                <CustomInput
                  type='text'
                  value={value}
                  autoComplete='off'
                  id={name}
                  name={name}
                  error={invalid}
                  errorText={'Please enter a valid phone number'}
                  onChange={(e) => {
                    const onlyNums = e.target.value.replace(/\D/g, ''); // remove non-digits
                    onChange(onlyNums);
                  }}
                  width={inputWidth}
                  containerStyle={{ position: 'absolute' }}
                />
              );
            }}
          />
        </S1.PhoneInputWrap>
      </S1.PhoneRow>
    </S1.SectionBox>
  );
});

FinanceContactSection.displayName = 'FinanceContactSection';
